var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "advantage" }, [
    _c("div", { staticClass: "advantage__inner" }, [
      _c("div", { staticClass: "advantage__body" }, [
        _c("h3", { staticClass: "advantage__title" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.getData(["text", "title"])) + "\n      "
          )
        ]),
        _c("div", { staticClass: "advantage__text" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.getData(["text", "subtitle"])) +
              "\n      "
          )
        ])
      ]),
      _c("div", { staticClass: "advantage__img", style: _vm.backImg })
    ]),
    _c("a", { staticClass: "advantage__link", attrs: { href: _vm.href } }, [
      _vm._v("\n    " + _vm._s(_vm.linkText) + "\n  ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }